import React, { useEffect, useState } from "react";
import axios from "axios";
import { Megaphone, X } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NoticeBanner = () => {
  const [notice, setNotice] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/settings/notice`)
      .then((r) => {
        if (r.data.enabled && r.data.text) {
          setNotice(r.data.text);
          setDismissed(sessionStorage.getItem("spire-notice-dismissed") === r.data.text);
        }
      })
      .catch(() => {});
  }, []);

  if (!notice || dismissed) return null;

  return (
    <div className="bg-amber-100 border-b border-amber-200" role="status" data-testid="site-notice-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-start gap-3">
        <Megaphone className="h-5 w-5 mt-0.5 text-amber-800 shrink-0" aria-hidden="true" />
        <p className="flex-1 text-base text-amber-900">{notice}</p>
        <button
          onClick={() => {
            sessionStorage.setItem("spire-notice-dismissed", notice);
            setDismissed(true);
          }}
          className="rounded-lg p-1 text-amber-800 hover:bg-amber-200"
          aria-label="Dismiss notice"
          data-testid="site-notice-dismiss"
        >
          <X className="h-5 w-5" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
};
